import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-order\"><path fill=\"#fff\" fill-opacity=\".7\" d=\"M12.667 14.666H3.333a2 2 0 0 1-2-2V2A.667.667 0 0 1 2 1.333h9.334A.667.667 0 0 1 12 2v8h2.667v2.666a2 2 0 0 1-2 2ZM12 11.333v1.333a.667.667 0 1 0 1.334 0v-1.333H12Zm-1.333 2V2.666h-8v10a.666.666 0 0 0 .667.667h7.333ZM4 4.666h5.334V6H4V4.666Zm0 2.667h5.334v1.333H4V7.333ZM4 10h3.333v1.333H4V10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol